import { CHAPTERS } from "@/constants/summit";
import { Reveal } from "@/components/Reveal";

const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative py-24 sm:py-32 overflow-hidden">
    <span
      aria-hidden
      className="text-outline pointer-events-none absolute -top-6 right-0 select-none font-display text-[22vw] font-black leading-none tracking-tighter"
    >
      CHOICE
    </span>
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-16 max-w-2xl">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-400 mb-4">The Manifesto</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
          Four chapters. One decision.
        </h2>
      </Reveal>
      <div>
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.06}>
            <div className="group grid gap-4 border-t border-white/10 py-10 sm:grid-cols-12 sm:gap-8 sm:py-14 transition-colors duration-500 hover:border-brand-500/40">
              <span className="font-mono text-sm text-brand-400 sm:col-span-2">{c.num}</span>
              <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight sm:col-span-4 transition-colors duration-500 group-hover:text-brand-300">
                {c.title}
              </h3>
              <p className="text-base leading-relaxed text-white/55 sm:col-span-6">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
